import React from "react";
import { FaStar } from "react-icons/fa";
import "./StarIcons.css"

const StarIcons = () => {
  return (
    <>
      <FaStar id="cardStar" />
      <FaStar id="cardStar" />
      <FaStar id="cardStar" />
      <FaStar id="cardStar" />
      <FaStar id="cardStar" />
    </>
  );
};

export default StarIcons;
